import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DocumentTypeEnum } from '@core/enums/document/document-type.enum';
import {
  IAccessProfileListResponseDto,
  IAccessProfileResponseDto,
} from '@core/interfaces/api/access-management/access-profile-list-dto.interface';
import { IPolicyAcceptedResponseDto } from '@core/interfaces/api/policies/policy-accepted-response-dto.interface';
import { IPolicyDocumentResponseDto } from '@core/interfaces/api/policies/policy-document-response-dto.interface';
import { IVdoApiResponsePaginated } from '@core/interfaces/api/vdo-api-response.interface';
import { environment } from '@environments/environment';
import { AccessControlFeatureKey } from '@shared/constants/features.const';
import { Observable } from 'rxjs';
import { IAccessProfileCreateRequestDto } from '@core/interfaces/api/access-management/access-profile-create-dto.interface';

@Injectable({ providedIn: 'root' })
export class FtsAccessManagementApiService {
  private readonly baseUrl = `${environment.baseUrl}/access-management`;

  private readonly http = inject(HttpClient);

  getAllProfiles(): Observable<IVdoApiResponsePaginated<IAccessProfileListResponseDto>> {
    const reqParams = new HttpParams({
      fromObject: {
        page: '1',
        pageSize: '50000',
      },
    });

    return this.http.get<IVdoApiResponsePaginated<IAccessProfileListResponseDto>>(
      `${this.baseUrl}/profiles`,
      {
        params: reqParams,
      }
    );
  }

  createProfile(
    profileData: IAccessProfileCreateRequestDto
  ): Observable<IAccessProfileResponseDto> {
    return this.http.post<IAccessProfileResponseDto>(`${this.baseUrl}/profiles`, profileData);
  }

  updateProfile(
    id: string,
    profileData: IAccessProfileCreateRequestDto
  ): Observable<IAccessProfileResponseDto> {
    return this.http.put<IAccessProfileResponseDto>(`${this.baseUrl}/profiles/${id}`, profileData);
  }

  getAllFeatures(): Observable<IVdoApiResponsePaginated<AccessControlFeatureKey>> {
    return this.http.get<IVdoApiResponsePaginated<AccessControlFeatureKey>>(
      `${this.baseUrl}/features`
    );
  }

  getPolicyDocument(type: DocumentTypeEnum): Observable<IPolicyDocumentResponseDto> {
    return this.http.get<IPolicyDocumentResponseDto>(`${this.baseUrl}/user/terms/${type}`);
  }

  acceptPolicy(type: DocumentTypeEnum): Observable<IPolicyAcceptedResponseDto> {
    return this.http.post<IPolicyAcceptedResponseDto>(
      `${this.baseUrl}/user/terms/${type}/accept`,
      {}
    );
  }
}
